import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import { FC, useContext } from 'react';

import { Company, authContext } from '@staffedupusa/shared-components';
import CloseIcon from '@mui/icons-material/Close';
import { DateIcon, MessageIcon } from '../../../vectors/index';
import RockerboxMessagingForm from './RockerboxMessagingForm';

type Application = {
  company: Company;
};

type RockerboxMessagingModalProps = {
  isOpen: boolean;
  handleClose: () => void;
  application: Application;
};

const RockerboxMessagingModal: FC<RockerboxMessagingModalProps> = ({
  isOpen,
  handleClose,
  application,
}) => {
  const { authData } = useContext(authContext);
  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      disableEnforceFocus
    >
      <DialogTitle>
        <IconButton sx={{ position: 'absolute', top: 5, right: 5 }} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
        <br />
        <MessageIcon />
        <br />
        <Typography variant="h4">
          {application?.company?.s_name}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <RockerboxMessagingForm
          companyId={application.company.id}
          onUnreadSuccess={handleClose}
        />
      </DialogContent>
    </Dialog>
  );
};

export default RockerboxMessagingModal;
